import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HootsMenuComponent } from './hoots-menu.component';



@NgModule({
  declarations: [HootsMenuComponent],
  exports: [HootsMenuComponent],
  imports: [
    CommonModule
  ]
})
export class HootsMenuModule { }
